import { render, staticRenderFns } from "./select.vue?vue&type=template&id=b9b39c82"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b39c82')) {
      api.createRecord('b9b39c82', component.options)
    } else {
      api.reload('b9b39c82', component.options)
    }
    module.hot.accept("./select.vue?vue&type=template&id=b9b39c82", function () {
      api.rerender('b9b39c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/select.vue"
export default component.exports